export default __webpack_public_path__ + "static/media/99.4bf88172.jpg";